import { defineAsyncComponent } from 'vue'
export default {
  "standalone-snowplow-layout": defineAsyncComponent(() => import("/codebuild/output/src438516980/src/layouts/StandaloneSnowplowLayout.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/codebuild/output/src438516980/src/layouts/default.vue").then(m => m.default || m))
}